module.exports = "<div class=login> <header role=banner page-header class=header ng-class=containerClass></header> <main role=main ui-view=\"\" class=content-view></main> <footer role=contentinfo page-footer class=footer ng-class=containerClass></footer> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/login/login.html
// module id = 457
// module chunks = 0